import { useState } from 'react'

import {
    Button,
    Divider,
    makeStyles,
    Typography,
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField
} from '@material-ui/core'

import CreditCardIcon from '@material-ui/icons/CreditCard'

import { useBoolean, usePayment, useServiceUsage } from 'hooks'
import { SpacedGroup, UpdateCardDialog } from 'UI/Components'
import { formatDate, validateEmail } from 'modules/utils'

const useStyles = makeStyles(theme => ({
    bold: {
        fontWeight: theme.fontWeightBold
    },
    headCell: {
        color: theme.palette.text.secondary,
        paddingBottom: theme.spacing(2),
        borderBottom: 'none'
    }
}))

const createData = (
    date: number,
    period: string,
    price: number,
    seats: number,
    description?: string
) => {
    return {
        date: formatDate(date),
        period,
        price,
        seats,
        description: description || '-'
    }
}

const BILLING_HISTORY_DISABLED = true

export const BillingTab = () => {
    const classes = useStyles()
    const updateDialog = useBoolean()

    const { billingEmail, nextBilling, isTrialPlan } = useServiceUsage()
    const { paymentMethod, cardDataIsEmpty, updateEmail, isLoading } = usePayment()
    const { cardBrand, last4 } = paymentMethod

    const [email, setBillingEmail] = useState(billingEmail)

    // keep calm backend is not ready :)
    const rows = [
        createData(1637054949, 'Basic / Yearly', 6.0, 24, 'Description'),
        createData(1632054949, 'Basic / Yearly', 9, 37, 'hahahaha'),
        createData(1635054949, 'Pro / Yearly', 16, 24, '6'),
        createData(1631054949, 'Pro / Yearly', 3, 67),
        createData(1632054949, 'Enterprise / Yearly', 16, 49)
    ]

    const historyIsEmpty = rows?.length

    const showSave = validateEmail(email) && email !== billingEmail

    return (
        <>
            {updateDialog.isTrue && (
                <UpdateCardDialog
                    onClose={updateDialog.setFalse}
                    type={cardDataIsEmpty ? 'Create' : 'Update'}
                />
            )}

            <Typography variant="subtitle2" className={classes.bold}>
                Payment method
            </Typography>

            {!cardDataIsEmpty && (
                <SpacedGroup spacing={2} mt={1}>
                    <SpacedGroup spacing={1}>
                        <CreditCardIcon />
                        <Typography variant="subtitle2" className={classes.bold}>
                            {cardBrand?.toUpperCase()}
                        </Typography>
                    </SpacedGroup>
                    <SpacedGroup spacing={2}>
                        <Typography variant="subtitle2" className={classes.bold}>
                            ...{last4}
                        </Typography>
                        <Button variant="text" color="primary" onClick={updateDialog.setTrue}>
                            Update
                        </Button>
                    </SpacedGroup>
                </SpacedGroup>
            )}
            {cardDataIsEmpty && (
                <SpacedGroup mt={2}>
                    <Button size="small" onClick={updateDialog.setTrue}>
                        Add card
                    </Button>
                </SpacedGroup>
            )}
            {nextBilling && !isTrialPlan && (
                <Box mt={2}>
                    <Typography variant="subtitle2" className={classes.bold}>
                        Next Billing
                    </Typography>
                    <Box mt={2}>
                        <Typography>{formatDate(nextBilling)}</Typography>
                    </Box>
                </Box>
            )}
            <Box mt={2}>
                <Typography variant="subtitle2" className={classes.bold}>
                    Billing email
                </Typography>

                <SpacedGroup mt={2}>
                    <TextField
                        required
                        variant="outlined"
                        size="small"
                        value={email}
                        onChange={e => setBillingEmail(e.target.value)}
                    />
                    {showSave && (
                        <Button onClick={() => updateEmail(email)} disabled={isLoading}>
                            Save
                        </Button>
                    )}
                </SpacedGroup>
            </Box>

            {!BILLING_HISTORY_DISABLED && (
                <>
                    <Box my={3}>
                        <Divider />
                    </Box>
                    <Typography variant="subtitle2" className={classes.bold}>
                        Billing History
                    </Typography>

                    <Box mt={3} />
                    {historyIsEmpty ? (
                        <Typography align="center">Billing history is empty</Typography>
                    ) : (
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.headCell}>Date</TableCell>
                                        <TableCell className={classes.headCell}>Period</TableCell>
                                        <TableCell className={classes.headCell}>Price</TableCell>
                                        <TableCell className={classes.headCell}>Seats</TableCell>
                                        <TableCell className={classes.headCell}>
                                            Description
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row, i) => (
                                        <TableRow key={i}>
                                            <TableCell style={{ maxWidth: '80px' }}>
                                                {row.date}
                                            </TableCell>
                                            <TableCell>{row.period}</TableCell>
                                            <TableCell>{row.price}</TableCell>
                                            <TableCell>{row.seats}</TableCell>
                                            <TableCell>{row.description}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </>
            )}
        </>
    )
}
